export default __webpack_public_path__ + "static/media/press-03.b417c9c8.jpg";